import { Button, Form } from '@bancobarigui/barihaus';

type Props = {
  onClickCancel: () => void;
  loading?: boolean;
};

export function RegisterFormButtons({ onClickCancel, loading = false }: Props) {
  return (
    <div className="right-0 flex flex-row gap-6">
      <Button onClick={onClickCancel} type="default" disabled={loading} size="large">
        Cancelar
      </Button>

      <Form.Item>
        <Button
          htmlType="submit"
          buttonColor="primary"
          loading={loading}
          size="large"
        >
          Cadastrar
        </Button>
      </Form.Item>
    </div>
  );
}
